import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter} from 'rxjs/operators';
//import { GridOptions, ColDef, AllModules} from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from "ag-grid-community";

import { RouterLinkRendererComponent } from '../ag-grid/router-link-renderer.component';
import { ModalInfoComponent } from "../ag-grid/modal-info.component";
import { PendingFlow } from '../../../flow/models/flow.model';
import { FlowInstanceService } from '../../../flow/services/flow-instance.service';
import { dateComparator } from '../data-table/comparators/data-table.comparators';
import { GridFormatterService } from '../../services/grid-formatter.service';
import { AuthService } from "../../../services/auth.service";
import { OrganizationComplianceDetails } from "../../models/organization.model";

@Component({
    selector: 'fa-awaiting-return',
    templateUrl: './fa-awaiting-return.component.html',
    standalone: false
})
export class FinancialAssuranceAwaitingReturnComponent implements OnInit, OnDestroy {

    @Input() isInternal: boolean = false;
    @Input() public orgId: string;
    frameworkComponents: any;
    @Input() complianceData: OrganizationComplianceDetails[];
    @Input() gridAriaLabel: string;


    columnDateCompleted: ColDef = {
        headerClass: "wrapped",
        headerName: "Approved",
        headerTooltip: "Approved",
        tooltipValueGetter: this.formatterService.formatDate("approvedDate"),
        field: "approvedDate",
        valueGetter: this.formatterService.formatDate("approvedDate"),
        comparator: dateComparator,
        filter: "agDateColumnFilter",
        filterParams: this.formatterService.defaultDateFilterParams
    };

    columnInternalApplicationNumber: ColDef = {
        headerClass: "wrapped",
        headerName: "Application Number",
        headerTooltip: "Application Number",
        field: "flowIdentifier",
        cellRenderer: RouterLinkRendererComponent,
        cellRendererParams: { textField: "flowIdentifier", flowIdField: "flowId", workItemIdField: "currentWorkItemId" },        
        tooltipField: "flowIdentifier",
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams 
    }

    columnInternalCompanyName: ColDef = {
        headerClass: "wrapped",
        headerName: "Company",
        headerTooltip: "Company",
        field: "companyName",
        tooltipField: "companyName",
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams
    }

    columnType: ColDef = {
        headerClass: "wrapped",
        headerName: "Type",
        headerTooltip: "Type",
        tooltipField: "type",
        field: "type",
        filterParams: this.formatterService.defaultTextFilterParams
    };

    columnAmount: ColDef = {
        headerClass: "wrapped",
        headerName: "Amount",
        headerTooltip: "Amount",
        field: "amount",
        tooltipValueGetter: this.formatterService.formatCurrency("amount", "USD", "symbol", "1.2-2"),
        valueFormatter: this.formatterService.formatCurrency("amount", "USD", "symbol", "1.2-2"),
        filterParams: this.formatterService.defaultNumberFilterParams,
        filter: "agNumberColumnFilter"
    };

    ownerTypeColumn: ColDef = {
        headerClass: "wrapped",
        headerName: "Owner Type",
        headerTooltip: "Owner Type",
        tooltipValueGetter: this.formatOwnerType(),
        valueGetter: this.formatOwnerType(),
        minWidth: 110
    }

    data: PendingFlow[];
	gridOptions: GridOptions;
	gridApi?: GridApi;
    subscriptions: Subscription = new Subscription();

    gridColumns = [
        this.columnDateCompleted,
        this.columnInternalApplicationNumber,
        this.columnInternalCompanyName,
        this.ownerTypeColumn,
        this.columnType,
        this.columnAmount
    ];

    constructor(
        private formatterService: GridFormatterService,
        public flowInstanceService: FlowInstanceService,
        private router: Router,
        private auth: AuthService
    ) {
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    ngOnInit() {
        this.refreshData();

        this.gridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns((this.gridColumns));
        this.gridOptions.isExternalFilterPresent = () => false;
        this.gridOptions.headerHeight = 50;
		this.gridOptions.onGridReady = (params) => { this.gridApi = params.api; };
        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscriptions.unsubscribe();
        });
    }

    formatOwnerType(): any {
        return (obj) => {
            let returnValue: string = "";
            if (obj.data != null && obj.data["organizationId"] != null && this.complianceData != null) {
                let organizationId = obj.data["organizationId"];
                let compliance = this.complianceData.find(c => c.orgId == organizationId);
                if (compliance != null) {
                    if (compliance.isBrineHauler != null) {
                        if (compliance.isBrineHauler == true) returnValue = "Brine Hauler";
                    }
                    if (compliance.isWellOwner != null) {
                        if (compliance.isWellOwner == true) {
                            if (returnValue.length > 0) {
                                returnValue += ", ";
                            }
                            returnValue += "Well Owner";
                        }
                    }
                }

            }
            if (returnValue.length === 0) returnValue = "N/A";
            return returnValue;
        }
    }

    refreshData(): void {
        this.subscriptions.add(this.flowInstanceService.getReturnedIncompleteApplication('FinancialAssuranceAwaitingFinancialInstrumentReturn', true, this.orgId).subscribe(
            data => {
                data.forEach(d => {
                    if (!d.dateSubmitted) d.dateSubmitted = d.createdDate;
                });
                this.data = data.sort((a, b) => a.dateSubmitted > b.dateSubmitted ? 1 : -1);
                this.resizeColumns();
            },
            error => { console.log(error); alert("ERROR Fetching Awaiting Financial Instrument Return Applications"); }
        ));
    }

    resizeColumns(): void {
        if (this.gridApi) {
			this.gridApi.sizeColumnsToFit();
        }
    }
}
